enum VatsGoogleMapsEvents {
    LoadMap = 'LoadMap',
    PolygonComplete = 'PolygonComplete',
    PolygonEdited = 'PolygonEdited',
    PolygonCleared = 'PolygonCleared',
    PolygonLoaded = 'PolygonLoaded',
    PolygonChanged = 'PolygonChanged',
    LoadPolygon = 'LoadPolygon',
    ClearPolygon = 'ClearPolygon',
    PanTo = 'PanTo'
}

export default VatsGoogleMapsEvents;
